export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список АК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
